import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {Radio} from '@rmwc/radio'
import {TextFieldHelperText} from '../text-field-helper-text'
import {Typography} from '../../typography'
import styled from 'styled-components'

// TODO Adnan: Move to base
export const RadioField = ({field, label, options, error, form, style, className, handleInit, handleChange, normalize, helperText, ...props}) => {
  useEffect(() => {
    const {name, value} = field
    if (value) {
      const normalizedValue = normalize(value)
      form.setFieldValue(name, normalizedValue)
      handleInit(normalizedValue, name, form)
    }
  }, [])

  const onChange = (e) => {
    const {name} = field
    const normalizedValue = normalize(e.target.value)
    form.setFieldValue(name, normalizedValue)
    handleChange(normalizedValue, name, form)
  }

  return (
    <div className={`${error ? ' is-invalid' : ''}`}>
      <Typography use="body-small-regular" tag="label" style={{opacity: '.5', marginBottom: '.25rem'}}>
        {label}
      </Typography>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        {options.map((option, index) => (
          <StyledRadio
            key={index}
            name={field.name}
            checked={_.toString(field.value) === option.value}
            value={option.value || ''}
            onChange={onChange}
            {..._.omit(props, ['helperText', 'form', 'handleInit', 'handleChange', 'normalize', 'handleClick'])}>
            {option.label}
          </StyledRadio>
        ))}
      </div>
      {error && (
        <TextFieldHelperText persistent validationMsg style={style} className={className}>
          {error}
        </TextFieldHelperText>
      )}
      {!error && (
        <TextFieldHelperText style={style} className={className}>
          {helperText}
        </TextFieldHelperText>
      )}
    </div>
  )
}

const StyledRadio = styled(Radio)`
  &&& {
    border: solid ${(props) => (props.checked ? '1px  var(--mdc-theme-primary2)' : '1px var(--mdc-theme-neutral3)')};
    background: ${(props) => (props.checked ? ' rgba(var(--mdc-theme-primary2-rgb), 0.05)' : 'var(--mdc-theme-neutral)')};
    border-radius: 8px;
    cursor: pointer;
    * {
      cursor: pointer;
    }

    margin: 0.8rem 0;
    padding: 0.8rem;
    &:hover {
      border: solid 1px var(--mdc-theme-primary2);
      background: rgba(var(--mdc-theme-primary2-rgb), 0.05);
    }
    .mdc-radio .mdc-radio__native-control {
      width: 14px;
      height: 14px;
    }
    .mdc-radio__background {
      width: 14px;
      height: 14px;
    }
    .mdc-radio__outer-circle {
      border-color: var(--mdc-theme-primary2) !important;
    }
    .mdc-radio .mdc-radio__native-control:enabled + .mdc-radio__background .mdc-radio__inner-circle {
      border-color: var(--mdc-theme-primary2) !important;
      border-width: 1px;
    }

    .mdc-radio__native-control:checked + .mdc-radio__background .mdc-radio__inner-circle {
      background-color: var(--mdc-theme-primary2) !important;
    }
    .mdc-radio {
      height: 14px;
      width: 14px;
      padding: 10px;
    }
  }
`

RadioField.propTypes = {
  field: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  error: PropTypes.string,
  form: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    })
  ).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  handleInit: PropTypes.func,
  handleChange: PropTypes.func,
  normalize: PropTypes.func,
  helperText: PropTypes.string
}

RadioField.defaultProps = {
  style: {},
  className: '',
  helperText: '',
  handleInit: () => {},
  handleChange: () => {},
  handleClick: () => {},
  normalize: (value) => value
}
